import { getPersonalLoanAccount } from "../api";
import { transformPLDetails } from "./transforms";
import { Account } from "./types";

export async function getPLAccount(accountId: string): Promise<Account> {
  const { data } = await getPersonalLoanAccount(accountId);

  return transformPLDetails(data);
}
